export function generateUniqueKey(prefix: string, index: number, index2?: number): string {
    const key = `${prefix}-${index}`;
    if (index2) {
        return `${key}-${index2}`;
    }
    return key;
}
